import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { useAuth } from '../context/AuthContext'
import {
  acceptChallenge,
  createChallenge,
  createLeague,
  fetchChallenges,
  fetchLeaderboard,
  fetchLeagues,
  fetchMyPredictions,
  fetchProfile,
  fetchUpcomingEvent,
  joinLeague,
  savePrediction
} from '../lib/api'

export function useUpcomingEvent() {
  return useQuery({ queryKey: ['upcoming-event'], queryFn: fetchUpcomingEvent, staleTime: 60_000 })
}

export function useCreateLeague() {
  const queryClient = useQueryClient()
  return useMutation({ mutationFn: createLeague, onSuccess: () => queryClient.invalidateQueries({ queryKey: ['leagues'] }) })
}

export function useJoinLeague() {
  const queryClient = useQueryClient()
  return useMutation({ mutationFn: joinLeague, onSuccess: () => queryClient.invalidateQueries({ queryKey: ['leagues'] }) })
}

export function useCreateChallenge() {
  const queryClient = useQueryClient()
  return useMutation({ mutationFn: createChallenge, onSuccess: () => queryClient.invalidateQueries({ queryKey: ['challenges'] }) })
}

export function useAcceptChallenge() {
  const queryClient = useQueryClient()
  return useMutation({ mutationFn: acceptChallenge, onSuccess: () => queryClient.invalidateQueries({ queryKey: ['challenges'] }) })
}

export function useMyPredictions() {
  const { user } = useAuth()
  return useQuery({
    queryKey: ['predictions', user?.id],
    queryFn: () => fetchMyPredictions(user?.id),
    enabled: Boolean(user),
    staleTime: 20_000
  })
}

export function useSavePrediction() {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: savePrediction,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: ['predictions'] })
  })
}

export function useLeaderboard(period: string) {
  return useQuery({ queryKey: ['leaderboard', period], queryFn: () => fetchLeaderboard(period), staleTime: 60_000 })
}

export function useProfile(username?: string) {
  return useQuery({ queryKey: ['profile', username], queryFn: () => fetchProfile(username), staleTime: 60_000 })
}

export function useLeagues() {
  return useQuery({ queryKey: ['leagues'], queryFn: fetchLeagues, staleTime: 30_000 })
}

export function useChallenges() {
  return useQuery({ queryKey: ['challenges'], queryFn: fetchChallenges, staleTime: 30_000 })
}
